import { render, staticRenderFns } from "./RTC.vue?vue&type=template&id=43ab6622&scoped=true&"
import script from "./RTC.vue?vue&type=script&lang=js&"
export * from "./RTC.vue?vue&type=script&lang=js&"
import style0 from "./RTC.vue?vue&type=style&index=0&id=43ab6622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ab6622",
  null
  
)

export default component.exports